import { Injectable } from '@angular/core'
import { KopioijaPalvelu } from '@lemon/core-firebase/service/kopioija.service'
import { TimestampService } from '../../../_jaettu-angular/service/timestamp-service'
import { Kirjanpitaja } from '../../../_jaettu-lemonator/model/kirjanpitaja'

@Injectable()
export class KirjanpitajaKopioija {
  constructor(
    private kopioijaPalvelu: KopioijaPalvelu,
    private timestampService: TimestampService,
  ) {}

  public annaUusiKirjanpitaja(): Kirjanpitaja {
    return {
      avain: '',
      etunimi: '',
      sukunimi: '',
      luotu: this.timestampService.now(),
      luoja: '',
      paivitetty: this.timestampService.now(),
      paivittaja: '',
      poistettu: false,
      lemonaidUid: null,
      lemonaidAsiakasAvain: null,
      email: '',
      aloitti: null,
    }
  }

  public kopioiKirjanpitaja(kopioitava: Kirjanpitaja): Kirjanpitaja {
    return this.kopioijaPalvelu.kopioiJaAsetaNullPuuttuville<Kirjanpitaja>(kopioitava)
  }
}
